import { combineReducers } from 'redux';
import configReducer from './config.slice';
import userReducer from './user.slice';
import rulesReducer from './rules.slice';
import reportsReducer from './reports.slice';
import notificationReducer from './notification.slice';
import breadcrumbsReducer from './breadcrumbs.slice';
import tablesReducer from './tables.slice';
import usersReducer from './users.slice';
import appstateReducer from './appstate.slice';
import groupReducer from './group.slice';
import groupViewReducer from './groupView.slice';
import importExportSidePanelReducer from './importExportSidePanel.slice';

export default combineReducers({
    userReducer,
    configReducer,
    rulesReducer,
    reportsReducer,
    notificationReducer,
    breadcrumbsReducer,
    tablesReducer,
    usersReducer,
    appstateReducer,
    groupReducer,
    groupViewReducer,
    importExportSidePanelReducer
});

export * from './rules.slice';
export * from './reports.slice';
export * from './notification.slice';
export * from './breadcrumbs.slice';
export * from './tables.slice';
export * from './users.slice';
export * from './user.slice';
export * from './appstate.slice';
export * from './group.slice';
export * from './groupView.slice';
export * from './importExportSidePanel.slice';
